import { useLocation, useNavigate } from "react-router-dom";
import {
  EmptyBooking,
  EmptyInbox,
  EmptyNft,
  EmptyProperty,
  LightIcon,
  UnVerified,
  VerifyUserIcon,
} from "../../../AssetComponents/Images";
import { BlackButton } from "../../../Components/Buttons/BlackButton";
import { PurpleButton } from "../../../Components/Buttons/PurpleButton";
import {
  SelectionGroup,
  SelectionItem,
} from "../../../Components/Selection/Selection";
import { useDispatch, useSelector } from "react-redux";
import { useState, useEffect, useRef, useCallback, useMemo } from "react";
import { RentalItem } from "../../../Components/RealEstateProperty/RentalItem";
import {
  getMyTrips,
  getProfileFromWallet,
  truncateWalletAddress,
  navigateToMessageNotificationInbox,
  resolveNftFromStore,
  isSameWalletAddress,
} from "../../../Components/functions/Functions";
import { UserBoxIcon } from "../../../AssetComponents/Images";
import { api } from "../../../Components/functions/Api";
import { Fade } from "react-awesome-reveal";
import { clearNFTDetails } from "../../../ReduxSlices/NFTSlice";
import { resetSearchState } from "../../../ReduxSlices/SearchSlice";
import { removeNotificationById } from "../../../ReduxSlices/NotificationSlice";
import Veified from "../../../Components/DashBoardSvg/Veified";
import NoTripsyet from "../../../Components/DashBoardSvg/NoTripsyet";
import FindMore from "../../../Components/DashBoardSvg/FindMore";
import NoWishList from "../../../Components/DashBoardSvg/NoWishList";
import { NotificationImageWithFallback } from "../../../Components/Images/ImageWithFallback";
import { PropertyImageWithFallback } from "../../../Components/Images/PropertyImageWithFallback";
import { getRoleSpecificVerification } from "../../../utils/verificationUtils";
import { validatePropertyData } from "../../../utils/propertyValidation";
export const TravelerDashboard = () => {
  const navigate = useNavigate();
  const currentProfile = useSelector((state) => state.auth.profile);
  const account = useSelector((state) => state.auth.account);
  const diffToUTC = useSelector((state) => state.time.diffToUTC);
  const nfts = useSelector((state) => state.nft.nfts);
  const diff = useSelector((state) => state.time.diffToUTC);
  const notificationContent = useSelector((state) => state.notification.items);
  const [myTrips, setMyTrips] = useState([]);
  const ref_requests = useRef();
  const [profiles, setProfiles] = useState({});
  const [wishlist, setWishlist] = useState([]);
  const [flag, setFlag] = useState(0);
  // const location = useLocation();
   const dispatch = useDispatch();
  const location = useLocation();
  const [wishlistNFTs, setWishlistNFTs] = useState([]);
  const [loadingWishlist, setLoadingWishlist] = useState(false);
  const [isHydrating, setIsHydrating] = useState(true);
  const STATUS_MAP = ["upcoming", "current", "completed", "cancelled"];
  const [backendTripsByStatus, setBackendTripsByStatus] = useState({
    upcoming: [],
    current: [],
    completed: [],
    cancelled: [],
  });

  const normalizedAccount = useMemo(
    () => (account ? account.toLowerCase().trim() : null),
    [account]
  );
  
  useEffect(() => {
    // Clear any problematic Redux state when returning to dashboard
    dispatch(clearNFTDetails());
    dispatch(resetSearchState());
  }, []);

  // Hydrate all trips into Redux so this dashboard matches /traveler/trips.
  useEffect(() => {
    let cancelled = false;

    const hydrate = async () => {
      try {
        if (!normalizedAccount) return;

        const PAGE_SIZE = 20;
        // Fetch from backend directly so this dashboard doesn't depend on Redux NFT store shape/timing.
        const temp = {
          upcoming: [],
          current: [],
          completed: [],
          cancelled: [],
        };

        // Backend appears to support explicit status values, so we fetch each tab explicitly.
        for (const status of STATUS_MAP) {
          let page = 1;
          while (true) {
            const res = await getMyTrips({
              account: normalizedAccount,
              status,
              diffToUTC,
              page,
              limit: PAGE_SIZE,
              dispatch: undefined,
            });

            if (cancelled) return;

            temp[status] = [...temp[status], ...(res?.trips || [])];

            if (!res?.hasMore) break;
            page += 1;

            // Safety guard to prevent infinite loops.
            if (page > 1000) break;
          }
        }

        if (!cancelled) setBackendTripsByStatus(temp);
      } catch (e) {
        console.error("TravelerDashboard: failed to hydrate trips:", e);
      } finally {
        if (!cancelled) setIsHydrating(false);
      }
    };

    hydrate();
    return () => {
      cancelled = true;
    };
  }, [normalizedAccount, diffToUTC, dispatch]);
  
  useEffect(() => {
    // Reset any local component state that might be causing issues
    setFlag(0); // Reset trip filter to default
    setLoadingWishlist(false);
  }, [location.pathname]); // Trigger when route changes
  
  const loadWishlistNFTs = async () => {
    if (wishlist.length === 0) {
      setWishlistNFTs([]);
      return;
    }
    
    setLoadingWishlist(true);
    try {
      // Get properties for wishlist items
      const response = await api("property/getProperties", {
        token_ids: wishlist
      });
      
      if (response && Array.isArray(response)) {
        setWishlistNFTs(response);
      }
    } catch (error) {
      console.error("Error loading wishlist NFTs:", error);
    } finally {
      setLoadingWishlist(false);
    }
  };

  // Add this useEffect to load wishlist NFTs when wishlist changes
  useEffect(() => {
    loadWishlistNFTs();
  }, [wishlist]);

  const getWishlist = useCallback(async (forceRefresh = false) => {
    if (!account) return;
    
    try {
      const res = await api("user/getWishlist", {
        account: account,
      });
      
      // Always update with fresh data from server
      // Don't compare - just trust the server response
      setWishlist(res || []);
    } catch (error) {
      console.error("Error fetching wishlist:", error);
      setWishlist([]); // Clear on error
    }
  }, [account]);
  
  useEffect(() => {
    if (account) {
      getWishlist(true); // Force refresh on mount
    }
  }, [account, getWishlist]);

  // Listen for wishlist updates and refresh
  useEffect(() => {
    let refreshTimeout = null;
    
    const handleWishlistUpdate = () => {
      if (account) {
        // Clear any pending refresh
        if (refreshTimeout) {
          clearTimeout(refreshTimeout);
        }
        
        // Force refresh with cache-busting
        refreshTimeout = setTimeout(() => {
          getWishlist(true); // Force refresh
        }, 200);
      }
    };

    window.addEventListener('wishlistUpdated', handleWishlistUpdate);

    return () => {
      if (refreshTimeout) {
        clearTimeout(refreshTimeout);
      }
      window.removeEventListener('wishlistUpdated', handleWishlistUpdate);
    };
  }, [account, getWishlist]);

  // 🚀 FIX: Refresh wishlist when page becomes visible (user switches back to tab)
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible' && account) {
        // Refresh wishlist when tab becomes visible
        getWishlist(true);
      }
    };

    const handleFocus = () => {
      if (account) {
        // Refresh wishlist when window regains focus
        getWishlist(true);
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener('focus', handleFocus);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('focus', handleFocus);
    };
  }, [account, getWishlist]);

  useEffect(() => {
    const array = Object.values(nfts);
    const temp = [];
    for (let i = 0; i < array.length; i++) {
      for (let j = 0; j < array[i].rentals?.rentals?.length; j++) {
        if (
          array[i].rentals?.rentals[j].address?.toLowerCase() ===
          normalizedAccount
        )
          temp.push(array[i]);
      }
    }

    setMyTrips(temp);
  }, [nfts, normalizedAccount]);

  // Helper function to check if there are any trips for the current flag
  const hasTripsForFlag = (flag) => {
    const status = STATUS_MAP[flag] || "upcoming";
    return (backendTripsByStatus?.[status] || []).length > 0;
  };

  const handleScrollLeft_ = () => {
    ref_requests.current.scrollTo({
      left: ref_requests.current.scrollLeft + 200,
      behavior: "smooth",
    });
  };

  const handleScrollRight_ = () => {
    ref_requests.current.scrollTo({
      left: ref_requests.current.scrollLeft - 200,
      behavior: "smooth",
    });
  };

  const getProfile = async (address, profiles) => {
    if (profiles[address] || profiles[address] === false) return;
    const profile = await getProfileFromWallet(address);
    profiles[address] = profile;
  };

  const parseAction = (action) => {
    switch (action) {
      case "finalize_short_term_rental":
        return (
          <div className="flex items-center">
            <div className="text-[#38A569]">Completed</div>
          </div>
        );
        break;
      case "set_reservation_for_short_term":
        return (
          <div className="flex items-center">
            <div className="text-[#38A569]">Reserved</div>
          </div>
        );
        break;
      case "cancel_reservation_for_shortterm":
        return (
          <div className="flex items-center">
            <div className="text-[#DB1F22]">Canceled</div>
          </div>
        );
        break;

      case "cancel_rental_for_shortterm":
        return (
          <div className="flex items-center">
            <div className="text-[#DB1F22]">Canceled</div>
          </div>
        );
        break;

      case "reject_reservation_for_shortterm":
        return (
          <div className="flex items-center">
            <div className="text-[#DB1F22]">Rejected</div>
          </div>
        );
        break;
      default:
        break;
    }
  };

  const getNotificationPath = (item, account, nfts) => {
    if (item.type === "message") {
      const nft = resolveNftFromStore(nfts, item.data?.nftId);
      const isPropertyOwner =
        nft?.access?.owner &&
        isSameWalletAddress(account, nft.access.owner);
      return isPropertyOwner
        ? `/dashboard/host/inbox?chat=${item.data.id}`
        : `/dashboard/traveler/inbox?chat=${item.data.id}`;
    }
    
    if (item.type === "event") {
      // Ensure token_id is valid
      const tokenId = item.data.token_id;
      if (!tokenId || tokenId === 'undefined' || tokenId === 'null') {
        return "/dashboard";
      }
      
      const nft = resolveNftFromStore(nfts, tokenId) || nfts[tokenId];
      const isOwner =
        nft?.access?.owner &&
        isSameWalletAddress(account, nft.access.owner);
      
      // Helper function to find renting_period from NFT data
      const getRentingPeriod = () => {
        // First, try to get from notification data directly
        if (item.data.renting_period && Array.isArray(item.data.renting_period) && item.data.renting_period.length === 2) {
          return item.data.renting_period;
        }
        
        // Otherwise, try to find from NFT rentals array
        if (nft?.rentals?.rentals && Array.isArray(nft.rentals.rentals)) {
          const action = item.data.action;
          const sender = item.data.sender;
          
          // For cancel/reject actions, find the cancelled/rejected reservation
          if (action === "cancel_reservation_for_shortterm" || 
              action === "cancel_rental_for_shortterm" || 
              action === "reject_reservation_for_shortterm") {
            // Find the most recent cancelled/rejected reservation
            for (let i = nft.rentals.rentals.length - 1; i >= 0; i--) {
              const reservation = nft.rentals.rentals[i];
              if (reservation.renting_period && 
                  Array.isArray(reservation.renting_period) && 
                  reservation.renting_period.length === 2 &&
                  (reservation.cancelled || (!reservation.approved && action === "reject_reservation_for_shortterm"))) {
                return reservation.renting_period;
              }
            }
          }
          
          // For finalize action, find the most recent finalized (approved) reservation
          if (action === "finalize_short_term_rental") {
            for (let i = nft.rentals.rentals.length - 1; i >= 0; i--) {
              const reservation = nft.rentals.rentals[i];
              if (reservation.renting_period && 
                  Array.isArray(reservation.renting_period) && 
                  reservation.renting_period.length === 2 &&
                  reservation.approved && 
                  !reservation.cancelled) {
                return reservation.renting_period;
              }
            }
          }
          
          // For set_reservation, find the most recent reservation that matches the sender
          if (action === "set_reservation_for_short_term") {
            for (let i = nft.rentals.rentals.length - 1; i >= 0; i--) {
              const reservation = nft.rentals.rentals[i];
              if (reservation.renting_period && 
                  Array.isArray(reservation.renting_period) && 
                  reservation.renting_period.length === 2 &&
                  reservation.address === sender) {
                return reservation.renting_period;
              }
            }
          }
          
          // Fallback: get the most recent reservation with valid renting_period
          for (let i = nft.rentals.rentals.length - 1; i >= 0; i--) {
            const reservation = nft.rentals.rentals[i];
            if (reservation.renting_period && 
                Array.isArray(reservation.renting_period) && 
                reservation.renting_period.length === 2) {
              return reservation.renting_period;
            }
          }
        }
        
        return null;
      };
      
      switch (item.data.action) {
        case "set_reservation_for_short_term":
        case "finalize_short_term_rental":
        case "cancel_reservation_for_shortterm":
        case "cancel_rental_for_shortterm":
        case "reject_reservation_for_shortterm":
          const rentingPeriod = getRentingPeriod();
          if (rentingPeriod && rentingPeriod.length === 2) {
            const from = rentingPeriod[0];
            const to = rentingPeriod[1];
            return isOwner 
              ? `/dashboard/host/reservations/${tokenId}?from=${from}&to=${to}` 
              : `/dashboard/traveler/trips/${tokenId}?from=${from}&to=${to}`;
          }
          
          // Fallback to reservations with token_id if we can't find renting_period
          return isOwner 
            ? `/dashboard/host/reservations/${tokenId}` 
            : `/dashboard/traveler/trips/${tokenId}`;
        
        default:
          // For any other event with a token_id, redirect to reservations
          return isOwner 
            ? `/dashboard/host/reservations/${tokenId}` 
            : `/dashboard/traveler/trips/${tokenId}`;
      }
    }
    
    return "/dashboard";
  };

  const getProfiles = async () => {
    let tempProfiles = {};
    for (let i = 0; i < notificationContent.length; i++) {
      if (notificationContent[i].type === "message") {
        getProfile(notificationContent[i].data.message.sender, tempProfiles);
      } else {
        getProfile(notificationContent[i].data.sender, tempProfiles);
      }
    }
    setProfiles(tempProfiles);
  };

  useEffect(() => {
    getProfiles();
  }, [notificationContent]);

  const setPeriodParams = (token_id, from, to) => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.set("from", from);
    searchParams.set("to", to);
    navigate(
      "/dashboard/traveler/trips" + `/${token_id}?${searchParams.toString()}`
    );
  };

  const formatDate = (timeUTC, diff) => {
    try {
      const timestamp = (Math.round(new Date(timeUTC).getTime() / 1000) - diff) * 1000;
      if (isNaN(timestamp) || !isFinite(timestamp)) {
        return 'Invalid date';
      }
      return {
        date: new Intl.DateTimeFormat("en-US", {
          day: "numeric",
          month: "short",
        }).format(timestamp),
        time: new Intl.DateTimeFormat("en-US", {
          hour: "numeric",
          minute: "2-digit",
          hour12: true,
        }).format(timestamp)
      };
    } catch (error) {
      console.error('Date formatting error:', error);
      return { date: 'Invalid date', time: 'Invalid time' };
    }
  };

  // Helper function to safely get image URL as string
  const getImageUrl = (nft, tokenId) => {
    const image = nft?.metaData?.images?.[0];
    if (!image) return null;
    // Convert to string if it's not already a string
    if (typeof image === 'string') return image;
    if (typeof image === 'object' && image.url) return image.url;
    return String(image);
  };

  return (
    <div className="select-none flex-1 min-w-0 max-h-[calc(100vh-80px)] h-full flex flex-col dashboard-container dashboard-no-scrollbars">
      {/* Scrollable Content */}
      <div className="flex-1 overflow-y-auto overflow-x-hidden p-[8px] sm:p-[10px]">
        <div className="w-full space-y-[16px] sm:space-y-[20px] rounded-[10px] p-[4px] sm:p-[8px] flex flex-col dashboard-content">
        
        {/* Welcome Header Section */}
        <div className="bg-white border-[2px] h-max border-[#E3E3E3] p-[16px] sm:p-[24px] rounded-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)] dashboard-card m-[8px] sm:m-[10px]">
          <div className="font-semibold text-[20px] sm:text-[24px]">Dashboard</div>
          <div className="text-[#666666] font-normal text-sm sm:text-base">
            Welcome to the Traveler Dashboard
          </div>
        </div>
        
        {/* Mobile Layout */}
        <div className="lg:hidden space-y-[16px] sm:space-y-[20px] w-full overflow-x-hidden">
        <div className="flex flex-col gap-[16px] sm:gap-[20px] px-[4px] sm:px-[10px] w-full overflow-x-hidden">
          <div className="w-full lg:min-w-[300px] lg:max-w-[300px] h-full min-h-[280px] lg:min-h-0 lg:flex-1 flex flex-col space-y-[8px] sm:space-y-[10px]">
            <div className="font-semibold text-sm sm:text-base">Verify NFTs</div>
            <div className="bg-white flex flex-col justify-around items-center border-[2px] h-full w-full border-[#E3E3E3] p-[16px] sm:p-[24px] rounded-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]">
              {currentProfile?.Avatar ? (
                <img
                  alt=""
                  src={currentProfile?.Avatar}
                  className="w-[60px] sm:w-[80px] rounded-full shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]"
                />
              ) : (
                <div className="scale-75 sm:scale-100">
                  <VerifyUserIcon />
                </div>
              )}
              {currentProfile?.Name ? (
                <div className="font-semibold text-sm sm:text-base text-center">
                  {currentProfile?.Name.replace("/", " ")}
                </div>
              ) : (
                <div className="font-semibold text-sm sm:text-base">Unknown</div>
              )}

              {(() => {
                const travelerVerification = getRoleSpecificVerification(currentProfile, 'traveler');
                return travelerVerification.isVerified ? (
                  <div className="flex items-center gap-[6px] sm:gap-[8px]">
                    <div className="scale-75 sm:scale-100">
                      <Veified/>
                    </div>
                    <div className="text-[#959595] font-normal text-[12px] sm:text-[14px]">
                      {travelerVerification.verificationText}
                    </div>
                  </div>
                ) : (
                  <div className="flex items-center gap-[8px] sm:gap-[10px]">
                    <div className="scale-75 sm:scale-100">
                      <UnVerified />
                    </div>
                    <div className="text-[#959595] font-normal text-[12px] sm:text-[14px]">
                      {travelerVerification.verificationText}
                    </div>
                  </div>
                );
              })()}
              
              {(() => {
                const travelerVerification = getRoleSpecificVerification(currentProfile, 'traveler');
                return travelerVerification.isVerified ? (
                  <div className="w-full">
                    <PurpleButton
                      text={
                        <div
                          onClick={() =>
                            navigate("/dashboard/profile?mode=traveler")
                          }
                          className="w-full text-center text-sm sm:text-base"
                        >
                          Your Profile
                        </div>
                      }
                    />
                  </div>
                ) : (
                  <div className="w-full">
                    <BlackButton
                      text={
                        <div
                          onClick={() =>
                            navigate("/dashboard/profile?mode=traveler")
                          }
                          className="w-full text-center text-sm sm:text-base"
                        >
                          Verify now
                        </div>
                      }
                    />
                  </div>
                );
              })()}
            </div>
          </div>

          <div className="relative w-full h-full flex flex-col space-y-[12px] sm:space-y-[16px]">
            <div className="font-semibold text-sm sm:text-base">All trips</div>

            <div
              ref={ref_requests}
              className="flex flex-col h-full min-h-[300px] lg:min-h-0 lg:flex-1 border-[2px] border-[#E3E3E3] bg-white top-0 w-full p-[12px] sm:p-[16px] pb-[16px] sm:pb-[20px] rounded-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)] overflow-hidden"
            >
              <div className="w-full flex flex-col sm:flex-row gap-[16px] sm:gap-[20px] justify-between items-start sm:items-center mb-[16px] sm:mb-[20px] flex-shrink-0">
                <SelectionGroup
                  defaultItem={flag}
                  className="border-[2px] border-[#e3e3e3] w-full sm:w-max px-[8px] sm:px-[12px] py-[6px] sm:py-[8px] gap-[4px] sm:gap-[12px] flex items-center rounded-[14px] bg-white shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]"
                >
                  <SelectionItem
                    SelectedItem={
                      <div className="py-[6px] sm:py-[8px] cursor-pointer bg-white rounded-[10px] w-full sm:w-[120px] flex justify-center gap-[4px] sm:gap-[12px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]">
                        <div className="text-black font-semibold text-[11px] sm:text-sm">Upcoming</div>
                        <div className="scale-75 sm:scale-100">
                          <LightIcon />
                        </div>
                      </div>
                    }
                    UnselectedItem={
                      <div
                        onClick={() => setFlag(0)}
                        className="py-[6px] sm:py-[8px] cursor-pointer hover:bg-[#f6f6f6] rounded-[10px] w-full sm:w-[120px] flex justify-center"
                      >
                        <div className="text-[#959595] text-[11px] sm:text-sm">Upcoming</div>
                      </div>
                    }
                  />
                  <SelectionItem
                    SelectedItem={
                      <div className="py-[6px] sm:py-[8px] cursor-pointer bg-white rounded-[10px] w-full sm:w-[120px] flex justify-center gap-[4px] sm:gap-[12px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]">
                        <div className="text-black font-semibold text-[11px] sm:text-sm">Current</div>
                        <div className="scale-75 sm:scale-100">
                          <LightIcon />
                        </div>
                      </div>
                    }
                    UnselectedItem={
                      <div
                        onClick={() => setFlag(1)}
                        className="py-[6px] sm:py-[8px] cursor-pointer hover:bg-[#f6f6f6] rounded-[10px] w-full sm:w-[120px] flex justify-center"
                      >
                        <div className="text-[#959595] text-[11px] sm:text-sm">Current</div>
                      </div>
                    }
                  />
                  <SelectionItem
                    SelectedItem={
                      <div className="py-[6px] sm:py-[8px] cursor-pointer bg-white rounded-[10px] w-full sm:w-[120px] flex justify-center gap-[4px] sm:gap-[12px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]">
                        <div className="text-black font-semibold text-[11px] sm:text-sm">
                          Completed
                        </div>
                        <div className="scale-75 sm:scale-100">
                          <LightIcon />
                        </div>
                      </div>
                    }
                    UnselectedItem={
                      <div
                        onClick={() => setFlag(2)}
                        className="py-[6px] sm:py-[8px] cursor-pointer hover:bg-[#f6f6f6] rounded-[10px] w-full sm:w-[120px] flex justify-center"
                      >
                        <div className="text-[#959595] text-[11px] sm:text-sm">Completed</div>
                      </div>
                    }
                  />
                  <SelectionItem
                    SelectedItem={
                      <div className="py-[6px] sm:py-[8px] cursor-pointer bg-white rounded-[10px] w-full sm:w-[120px] flex justify-center gap-[4px] sm:gap-[12px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]">
                        <div className="text-black font-semibold text-[11px] sm:text-sm">
                          Cancelled
                        </div>
                        <div className="scale-75 sm:scale-100">
                          <LightIcon />
                        </div>
                      </div>
                    }
                    UnselectedItem={
                      <div
                        onClick={() => setFlag(3)}
                        className="py-[6px] sm:py-[8px] cursor-pointer hover:bg-[#f6f6f6] rounded-[10px] w-full sm:w-[120px] flex justify-center"
                      >
                        <div className="text-[#959595] text-[11px] sm:text-sm">Cancelled</div>
                      </div>
                    }
                  />
                </SelectionGroup>
              </div>
              <div className="flex gap-[12px] sm:gap-[16px] items-center mt-[8px] sm:mt-[12px] w-full overflow-x-auto overflow-y-hidden pb-4 flex-1 min-h-0">
                {isHydrating ? (
                  <div className="flex flex-col justify-center px-4 items-center w-full py-[20px] sm:py-[32px] min-h-0 flex-1">
                    <div className="text-sm sm:text-base">Loading trips...</div>
                  </div>
                ) : hasTripsForFlag(flag) ? (
                  (backendTripsByStatus?.[STATUS_MAP[flag] || "upcoming"] ||
                    []).map(({ nft, reservation, key }, idx) => {
                    const period = reservation?.renting_period;
                    const start = Array.isArray(period) ? period[0] : 0;
                    const end = Array.isArray(period) ? period[1] : 0;
                    const validatedNft = validatePropertyData(nft);

                    return (
                      <Fade
                        key={
                          key ??
                          `${validatedNft.token_id}-${reservation?.address}-${start}-${end}-${idx}`
                        }
                      >
                        <div className="w-max h-max relative group flex-shrink-0">
                          <RentalItem
                            token_id={validatedNft.token_id}
                            tokenData={validatedNft}
                            onlyImages
                            traveler={reservation?.address}
                            rentingPeriod={
                              Array.isArray(period) ? period : undefined
                            }
                            cancelled={!!reservation?.cancelled}
                          />
                          <div className="group-hover:flex absolute top-0 left-0 w-full h-full hidden flex-col items-center justify-center">
                            <div className="scale-75 sm:scale-100">
                              <BlackButton
                                text="View all"
                                onClick={() =>
                                  setPeriodParams(
                                    validatedNft.token_id,
                                    start,
                                    end
                                  )
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </Fade>
                    );
                  })
                ) : (
                  <div className="flex flex-col justify-center px-4 items-center w-full py-[20px] sm:py-[32px] min-h-0 flex-1">
                    <div className="scale-75 sm:scale-100">
                      <NoTripsyet/>
                    </div>
                    <div className="flex flex-col items-center mt-[12px] sm:mt-[16px]">
                      <div className="font-semibold text-sm sm:text-base">
                        No Trips yet
                      </div>
                      <div className="text-[#a5a5a5] text-xs sm:text-sm text-center mt-[4px] sm:mt-[8px]">
                        {flag === 0 && "No upcoming trips yet, explore your trips"}
                        {flag === 1 && "No current trips yet"}
                        {flag === 2 && "No completed trips yet"}
                        {flag === 3 && "No cancelled trips yet"}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        
        <div className="flex flex-col xl:flex-row gap-[16px] sm:gap-[20px] px-[4px] sm:px-[10px] w-full min-h-[270px] xl:min-h-[400px]">
          <div className="w-full xl:min-w-[40%] h-full xl:min-h-[400px] flex flex-col space-y-[8px] sm:space-y-[10px]">
            <div className="font-semibold text-sm sm:text-base">Wishlist</div>
            <div className="bg-white flex flex-col justify-around items-center border-[2px] h-full w-full border-[#E3E3E3] p-2 rounded-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]">
              {loadingWishlist ? (
                <div className="flex items-center justify-center h-full">
                  <div className="text-center text-sm sm:text-base">Loading wishlist...</div>
                </div>
              ) : wishlistNFTs.length ? (
                <div className="flex w-full overflow-auto gap-3 py-1">
                  {wishlistNFTs.map((nft) => (
                    <Fade key={nft.token_id}>
                      <div className="w-max h-max relative group">
                        <RentalItem
                          showArrow={false}
                          token_id={nft.token_id}
                          tokenData={nft}
                          imageHeight={160}
                          onlyImages
                          forceWishlisted={true}
                        />
                        <div className="group-hover:flex absolute top-0 left-0 w-full h-full hidden flex-col items-center justify-center">
                          <div className="scale-75 sm:scale-100">
                            <BlackButton
                              text="View"
                              onClick={() =>
                                navigate("/rent/all" + `/${nft.token_id}`)
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </Fade>
                  ))}
                  <div className="min-w-[200px] sm:min-w-[240px] w-full bg-[#F3F3F3] rounded-[8px] flex flex-col items-center h-full justify-around border-dashed border-[2px] p-4">
                    <div className="scale-75 sm:scale-100">
                      <FindMore/>
                    </div>
                    <div className="flex flex-col items-center">
                      <div className="font-semibold text-sm sm:text-base">Find more</div>
                      <div className="text-[#959595] font-normal text-[12px] sm:text-[14px] text-center">
                        Add more to your wishlist
                      </div>
                    </div>
                    <div className="scale-75 sm:scale-100 w-full">
                      <PurpleButton
                        text={
                          <div className="min-w-[100px] text-center text-xs sm:text-sm">
                            Add more
                          </div>
                        }
                        onClick={() => navigate("/rent/all")}
                      />
                    </div>
                  </div>
                </div>
              ) : (
                <>
                  <div className="scale-75 sm:scale-100">
                    <NoWishList/>
                  </div>
                  <div className="flex flex-col items-center">
                    <div className="font-semibold text-sm sm:text-base">No wishlist yet</div>
                    <div className="text-[#959595] font-normal text-[12px] sm:text-[14px] text-center">
                      Your wishlist is empty yet
                    </div>
                  </div>
                                        <div className="scale-75 sm:scale-100 w-full max-w-[200px]">
                        <PurpleButton
                          text={
                            <div className="min-w-[100px] text-center text-xs sm:text-sm">
                              Find your wishlist
                            </div>
                          }
                          onClick={() => navigate("/rent/all")}
                        />
                      </div>
                </>
              )}
            </div>
          </div>
          
          <div className="w-full xl:max-w-[800px] h-full xl:min-h-[400px] flex flex-col space-y-[8px] sm:space-y-[10px]">
            <div className="font-semibold text-sm sm:text-base">Notifications</div>

            {notificationContent.length > 0 ? (
              <div className="bg-white space-y-[4px] border-[2px] h-full w-full overflow-auto border-[#E3E3E3] p-[8px] rounded-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]">
                {notificationContent
                  .slice()
                  .reverse()
                  .map((item, i) => {
                    if (item.type === "event") {
                      const formattedDate = formatDate(item.data.timeUTC, diff);
                      return (
                        <div
                          key={i}
                          onClick={() => {
                            // Remove notification when clicked
                            dispatch(removeNotificationById({
                              type: "event",
                              identifier: {
                                token_id: item.data.token_id,
                                sender: item.data.sender,
                                action: item.data.action,
                                txHash: item.data.txHash,
                              }
                            }));
                            const tokenId = item.data.token_id;
                            if (
                              nfts[tokenId]?.access.owner?.toLowerCase() ===
                              normalizedAccount
                            )
                              navigate(`/dashboard/host/reservations/${tokenId}`);
                            else navigate(`/dashboard/traveler/trips/${tokenId}`);
                          }}
                          className="hover:bg-[#f0f0f0] rounded-[4px] cursor-pointer p-[6px] w-full flex items-center justify-between"
                        >
                          <div className="flex items-center gap-2 sm:gap-3 min-w-0 flex-1">
                            <NotificationImageWithFallback
                              src={profiles[item.data.sender]?.Avatar}
                              alt="User Avatar"
                              className="shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)] flex-shrink-0"
                              size="lg"
                            />

                            <div className="min-w-0 flex-1">
                              <div className="text-xs sm:text-sm truncate">
                                {profiles[item.data.sender]?.Name
                                  ? profiles[item.data.sender]?.Name?.replace(
                                      "/",
                                      " "
                                    )
                                  : truncateWalletAddress(item.data.sender)}
                              </div>
                              <div className="flex gap-2 truncate">
                                <span className="font-semibold text-xs sm:text-sm">
                                  {parseAction(item.data.action)}
                                </span>
                                <span className="truncate text-xs sm:text-sm">
                                  {
                                    nfts[item.data.token_id]?.metaData
                                      .buildingName
                                  }
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="flex items-center gap-2 sm:gap-3 flex-shrink-0">
                            <PropertyImageWithFallback
                              src={getImageUrl(nfts[item.data.token_id], item.data.token_id)}
                              alt="Property"
                              className="w-[50px] sm:w-[60px] h-[50px] sm:h-[60px] rounded-[4px]"
                            />
                            <div className="hidden sm:block">
                              <div className="text-[12px] text-end">
                                {formattedDate.date}
                              </div>
                              <div className="text-[12px] text-end">
                                {formattedDate.time}
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    } else {
                      const formattedDate = formatDate(item.data.message.generatedTime, diff);
                      return (
                        <div
                          key={i}
                          onClick={async () => {
                            dispatch(removeNotificationById({
                              type: "message",
                              identifier: { chatId: item.data.id },
                            }));
                            await navigateToMessageNotificationInbox({
                              item,
                              account,
                              nfts,
                              pathname: location.pathname,
                              navigate,
                            });
                          }}
                          className="hover:bg-[#f0f0f0] rounded-[4px] cursor-pointer p-[6px] w-full flex items-center justify-between"
                        >
                          <div className="flex items-center gap-2 sm:gap-3 min-w-0 flex-1">
                            {profiles[item.data.message.sender]?.Avatar ? (
                              <img
                                alt=""
                                src={profiles[item.data.message.sender]?.Avatar}
                                className="w-[36px] h-[36px] sm:w-[44px] sm:h-[44px] rounded-full shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)] flex-shrink-0"
                              />
                            ) : (
                              <div className="w-[36px] h-[36px] sm:w-[44px] sm:h-[44px] flex bg-[#f0f0f0] rounded-full flex-shrink-0">
                                <div className="scale-75 sm:scale-100 m-auto">
                                  <UserBoxIcon />
                                </div>
                              </div>
                            )}

                            <div className="min-w-0 flex-1">
                              <div className="text-xs sm:text-sm truncate">
                                {profiles[item.data.message.sender]?.Name
                                  ? profiles[
                                      item.data.message.sender
                                    ]?.Name?.replace("/", " ")
                                  : truncateWalletAddress(
                                      item.data.message.sender
                                    )}
                              </div>

                              <div className="flex gap-2 truncate">
                                <span className="truncate text-xs sm:text-sm">
                                  Sent new message
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="flex items-center gap-2 sm:gap-3 flex-shrink-0">
                            <PropertyImageWithFallback
                              src={getImageUrl(nfts[item.data.nftId], item.data.nftId)}
                              alt="Property"
                              className="w-[50px] sm:w-[60px] h-[50px] sm:h-[60px] rounded-[4px]"
                            />
                            <div className="hidden sm:block">
                              <div className="text-[12px] text-end">
                                {formattedDate.date}
                              </div>
                              <div className="text-[12px] text-end">
                                {formattedDate.time}
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    }
                  })}
              </div>
            ) : (
              <div className="bg-white flex flex-col justify-around items-center border-[2px] h-full w-full border-[#E3E3E3] p-[16px] sm:p-[24px] rounded-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]">
                <Fade cascade>
                  <div className="scale-75 sm:scale-100">
                    <EmptyInbox />
                  </div>
                  <div className="flex flex-col items-center">
                    <div className="font-semibold text-sm sm:text-base">No notifications yet</div>
                    <div className="text-[#959595] font-normal text-[12px] sm:text-[14px] text-center">
                      Your inbox is empty yet
                    </div>
                  </div>
                  <div className="scale-75 sm:scale-100 w-full max-w-[200px]">
                    <PurpleButton
                      text={
                        <div className="min-w-[100px] text-center text-xs sm:text-sm">Inbox</div>
                      }
                      onClick={() => navigate("/dashboard/traveler/inbox")}
                    />
                  </div>
                </Fade>
              </div>
            )}
          </div>
        </div>
        </div>

        {/* Desktop Layout */}
        <div className="hidden lg:flex flex-col gap-6 w-full min-h-[400px] max-w-full overflow-hidden">
          {/* Top Row - Verify NFTs and All Trips */}
          <div className="flex gap-6 w-full min-h-[350px] overflow-hidden">
            {/* Verify NFTs Section */}
            <div className="flex flex-col space-y-4 w-[300px] flex-shrink-0 h-[350px]">
      <div className="font-semibold text-base">Verify NFTs</div>
      <div className="bg-white flex flex-col justify-around items-center border-[2px] h-full w-full border-[#E3E3E3] p-6 rounded-[10px] shadow">
                {currentProfile?.Avatar ? (
                  <img
                    alt=""
                    src={currentProfile?.Avatar}
                    className="w-[80px] rounded-full shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]"
                  />
                ) : (
                  <VerifyUserIcon />
                )}
                {currentProfile?.Name ? (
                  <div className="font-semibold text-base text-center">
                    {currentProfile?.Name.replace("/", " ")}
                  </div>
                ) : (
                  <div className="font-semibold text-base">Unknown</div>
                )}

                {(() => {
                  const travelerVerification = getRoleSpecificVerification(currentProfile, 'traveler');
                  return travelerVerification.isVerified ? (
                    <div className="flex items-center gap-2">
                      <Veified/>
                      <div className="text-[#959595] font-normal text-sm">
                        {travelerVerification.verificationText}
                      </div>
                    </div>
                  ) : (
                    <div className="flex items-center gap-2">
                      <UnVerified />
                      <div className="text-[#959595] font-normal text-sm">
                        {travelerVerification.verificationText}
                      </div>
                    </div>
                  );
                })()}
                
                {(() => {
                  const travelerVerification = getRoleSpecificVerification(currentProfile, 'traveler');
                  return travelerVerification.isVerified ? (
                    <div className="w-full">
                      <PurpleButton
                        text={
                          <div
                            onClick={() =>
                              navigate("/dashboard/profile?mode=traveler")
                            }
                            className="w-full text-center text-base"
                          >
                            Your Profile
                          </div>
                        }
                      />
                    </div>
                  ) : (
                    <div className="w-full">
                      <BlackButton
                        text={
                          <div
                            onClick={() =>
                              navigate("/dashboard/profile?mode=traveler")
                            }
                            className="w-full text-center text-base"
                          >
                            Verify now
                          </div>
                        }
                      />
                    </div>
                  );
                })()}
              </div>
            </div>

            {/* All Trips Section */}
          <div className="flex flex-col space-y-4 flex-1 h-[350px] min-w-0">
      <div className="font-semibold text-base">All trips</div>
      <div
        ref={ref_requests}
        className="flex flex-col h-full max-h-full border-[2px] border-[#E3E3E3] bg-white w-full p-4 pb-6 rounded-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)] overflow-hidden"
      >
                <div className="w-full flex flex-row gap-5 justify-between items-center mb-5 flex-shrink-0">
                  <SelectionGroup
                    defaultItem={flag}
                    className="border-[2px] border-[#e3e3e3] w-max px-3 py-2 gap-3 flex items-center rounded-[14px] bg-white shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]"
                  >
                    <SelectionItem
                      SelectedItem={
                        <div className="py-2 cursor-pointer bg-white rounded-[10px] w-[120px] flex justify-center gap-3 shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]">
                          <div className="text-black font-semibold text-sm">Upcoming</div>
                          <LightIcon />
                        </div>
                      }
                      UnselectedItem={
                        <div
                          onClick={() => setFlag(0)}
                          className="py-2 cursor-pointer hover:bg-[#f6f6f6] rounded-[10px] w-[120px] flex justify-center"
                        >
                          <div className="text-[#959595] text-sm">Upcoming</div>
                        </div>
                      }
                    />
                    <SelectionItem
                      SelectedItem={
                        <div className="py-2 cursor-pointer bg-white rounded-[10px] w-[120px] flex justify-center gap-3 shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]">
                          <div className="text-black font-semibold text-sm">Current</div>
                          <LightIcon />
                        </div>
                      }
                      UnselectedItem={
                        <div
                          onClick={() => setFlag(1)}
                          className="py-2 cursor-pointer hover:bg-[#f6f6f6] rounded-[10px] w-[120px] flex justify-center"
                        >
                          <div className="text-[#959595] text-sm">Current</div>
                        </div>
                      }
                    />
                    <SelectionItem
                      SelectedItem={
                        <div className="py-2 cursor-pointer bg-white rounded-[10px] w-[120px] flex justify-center gap-3 shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]">
                          <div className="text-black font-semibold text-sm">
                            Completed
                          </div>
                          <LightIcon />
                        </div>
                      }
                      UnselectedItem={
                        <div
                          onClick={() => setFlag(2)}
                          className="py-2 cursor-pointer hover:bg-[#f6f6f6] rounded-[10px] w-[120px] flex justify-center"
                        >
                          <div className="text-[#959595] text-sm">Completed</div>
                        </div>
                      }
                    />
                    <SelectionItem
                      SelectedItem={
                        <div className="py-2 cursor-pointer bg-white rounded-[10px] w-[120px] flex justify-center gap-3 shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]">
                          <div className="text-black font-semibold text-sm">
                            Cancelled
                          </div>
                          <LightIcon />
                        </div>
                      }
                      UnselectedItem={
                        <div
                          onClick={() => setFlag(3)}
                          className="py-2 cursor-pointer hover:bg-[#f6f6f6] rounded-[10px] w-[120px] flex justify-center"
                        >
                          <div className="text-[#959595] text-sm">Cancelled</div>
                        </div>
                      }
                    />
                  </SelectionGroup>
                </div>
                <div className="flex gap-4 items-center mt-3 w-full overflow-x-auto overflow-y-hidden pb-4 flex-1 min-h-0">
                  {isHydrating ? (
                    <div className="flex flex-col justify-center px-4 items-center w-full py-8 min-h-0 flex-1">
                      <div className="text-sm sm:text-base">Loading trips...</div>
                    </div>
                  ) : hasTripsForFlag(flag) ? (
                    (backendTripsByStatus?.[STATUS_MAP[flag] || "upcoming"] ||
                      []).map(({ nft, reservation, key }, idx) => {
                      const period = reservation?.renting_period;
                      const start = Array.isArray(period) ? period[0] : 0;
                      const end = Array.isArray(period) ? period[1] : 0;
                      const validatedNft = validatePropertyData(nft);

                      return (
                        <Fade
                          key={
                            key ??
                            `${validatedNft.token_id}-${reservation?.address}-${start}-${end}-${idx}`
                          }
                        >
                          <div className="w-max h-max relative group flex-shrink-0">
                            <RentalItem
                              token_id={validatedNft.token_id}
                              tokenData={validatedNft}
                              onlyImages
                              traveler={reservation?.address}
                              rentingPeriod={
                                Array.isArray(period) ? period : undefined
                              }
                              cancelled={!!reservation?.cancelled}
                            />
                            <div className="group-hover:flex absolute top-0 left-0 w-full h-full hidden flex-col items-center justify-center">
                              <BlackButton
                                text="View all"
                                onClick={() =>
                                  setPeriodParams(validatedNft.token_id, start, end)
                                }
                              />
                            </div>
                          </div>
                        </Fade>
                      );
                    })
                  ) : (
                    <div className="flex flex-col justify-center px-4 items-center w-full py-8 min-h-0 flex-1">
                      <div className="scale-100">
                        <NoTripsyet/>
                      </div>
                      <div className="flex flex-col items-center mt-4">
                        <div className="font-semibold text-base">
                          No Trips yet
                        </div>
                        <div className="text-[#a5a5a5] text-sm text-center mt-2">
                          {flag === 0 && "No upcoming trips yet, explore your trips"}
                          {flag === 1 && "No current trips yet"}
                          {flag === 2 && "No completed trips yet"}
                          {flag === 3 && "No cancelled trips yet"}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Bottom Row - Wishlist and Notifications */}
           <div className="flex gap-6 w-full min-h-[300px] mt-8 overflow-hidden">
    {/* Wishlist Section */}
    <div className="flex flex-col space-y-4 flex-1 min-w-0">
      <div className="font-semibold text-base">Wishlist</div>
      <div className="bg-white flex flex-col justify-around items-center border border-[#E3E3E3] rounded-[10px] p-6 shadow h-[220px] sm:h-[300px]">
                {loadingWishlist ? (
                  <div className="flex items-center justify-center h-full">
                    <div className="text-center text-base">Loading wishlist...</div>
                  </div>
                ) : wishlistNFTs.length ? (
                  <div className="flex w-full overflow-x-auto gap-3 py-1 h-full">
                    {wishlistNFTs.map((nft) => (
                      <Fade key={nft.token_id}>
                        <div className="w-max h-max relative group">
                          <RentalItem
                            showArrow={false}
                            token_id={nft.token_id}
                            tokenData={nft}
                            imageHeight={160}
                            onlyImages
                            forceWishlisted={true}
                          />
                          <div className="group-hover:flex absolute top-0 left-0 w-full h-full hidden flex-col items-center justify-center">
                            <BlackButton
                              text="View"
                              onClick={() =>
                                navigate("/rent/all" + `/${nft.token_id}`)
                              }
                            />
                          </div>
                        </div>
                      </Fade>
                    ))}
                    <div className="min-w-[240px] w-full bg-[#F3F3F3] rounded-[8px] flex flex-col items-center h-full justify-around border-dashed border-[2px] p-4">
                      <FindMore/>
                      <div className="flex flex-col items-center">
                        <div className="font-semibold text-base">Find more</div>
                        <div className="text-[#959595] font-normal text-sm text-center">
                          Add more to your wishlist
                        </div>
                      </div>
                      <div className="w-full">
                        <PurpleButton
                          text={
                            <div className="min-w-[100px] text-center text-sm">
                              Add more
                            </div>
                          }
                          onClick={() => navigate("/rent/all")}
                        />
                      </div>
                    </div>
                  </div>
                ) : (
                  <>
                    <NoWishList/>
                    <div className="flex flex-col items-center">
                      <div className="font-semibold text-base">No wishlist yet</div>
                      <div className="text-[#959595] font-normal text-sm text-center">
                        Your wishlist is empty yet
                      </div>
                    </div>
                    <div className="w-full max-w-[200px]">
                      <PurpleButton
                        text={
                          <div className="min-w-[100px] text-center text-sm">
                            Find your wishlist
                          </div>
                        }
                        onClick={() => navigate("/rent/all")}
                      />
                    </div>
                  </>
                )}
              </div>
            </div>
            
            {/* Notifications Section */}
    <div className="flex flex-col space-y-4 flex-1 min-w-0">
      <div className="font-semibold text-base">Notifications</div>

              {notificationContent.length > 0 ? (
      <div className="bg-white space-y-1 border border-[#E3E3E3] overflow-y-auto overflow-x-hidden rounded-[10px] p-2 shadow h-[220px] sm:h-[300px]">

                  {notificationContent
                    .slice()
                    .reverse()
                    .map((item, i) => {
                      if (item.type === "event") {
                        const formattedDate = formatDate(item.data.timeUTC, diff);
                        return (
                          <div
                            key={i}
                            onClick={() => {
                              // Remove notification when clicked
                              dispatch(removeNotificationById({
                                type: "event",
                                identifier: {
                                  token_id: item.data.token_id,
                                  sender: item.data.sender,
                                  action: item.data.action,
                                  txHash: item.data.txHash,
                                }
                              }));
                              const path = getNotificationPath(item, account, nfts);
                              navigate(path);
                            }}
                            className="hover:bg-[#f0f0f0] rounded-[4px] cursor-pointer p-2 w-full flex items-center justify-between"
                          >
                            <div className="flex items-center gap-3 min-w-0 flex-1">
                              {profiles[item.data.sender]?.Avatar ? (
                                <img
                                  alt=""
                                  src={profiles[item.data.sender]?.Avatar}
                                  className="w-[44px] h-[44px] rounded-full shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)] flex-shrink-0"
                                />
                              ) : (
                                <div className="w-[44px] h-[44px] flex bg-[#f0f0f0] rounded-full flex-shrink-0">
                                  <UserBoxIcon />
                                </div>
                              )}

                              <div className="min-w-0 flex-1">
                                <div className="text-sm truncate">
                                  {profiles[item.data.sender]?.Name
                                    ? profiles[item.data.sender]?.Name?.replace(
                                        "/",
                                        " "
                                      )
                                    : truncateWalletAddress(item.data.sender)}
                                </div>
                                <div className="flex gap-2 truncate">
                                  <span className="font-semibold text-sm">
                                    {parseAction(item.data.action)}
                                  </span>
                                  <span className="truncate text-sm">
                                    {
                                      nfts[item.data.token_id]?.metaData
                                        .buildingName
                                    }
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="flex items-center gap-3 flex-shrink-0">
                              <PropertyImageWithFallback
                                src={getImageUrl(nfts[item.data.token_id], item.data.token_id)}
                                alt="Property"
                                className="w-[60px] h-[60px] rounded-[4px]"
                              />
                              <div>
                                <div className="text-[12px] text-end">
                                  {formattedDate.date}
                                </div>
                                <div className="text-[12px] text-end">
                                  {formattedDate.time}
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      } else {
                        const formattedDate = formatDate(item.data.message.generatedTime, diff);
                        return (
                          <div
                            key={i}
                            onClick={async () => {
                              // Remove notification when clicked
                              dispatch(removeNotificationById({
                                type: "message",
                                identifier: {
                                  chatId: item.data.id,
                                }
                              }));
                              await navigateToMessageNotificationInbox({
                                item,
                                account,
                                nfts,
                                pathname: location.pathname,
                                navigate,
                              });
                            }}
                            className="hover:bg-[#f0f0f0] rounded-[4px] cursor-pointer p-2 w-full flex items-center justify-between"
                          >
                            <div className="flex items-center gap-3 min-w-0 flex-1">
                              {profiles[item.data.message.sender]?.Avatar ? (
                                <img
                                  alt=""
                                  src={profiles[item.data.message.sender]?.Avatar}
                                  className="w-[44px] h-[44px] rounded-full shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)] flex-shrink-0"
                                />
                              ) : (
                                <div className="w-[44px] h-[44px] flex bg-[#f0f0f0] rounded-full flex-shrink-0">
                                  <UserBoxIcon />
                                </div>
                              )}

                              <div className="min-w-0 flex-1">
                                <div className="text-sm truncate">
                                  {profiles[item.data.message.sender]?.Name
                                    ? profiles[
                                        item.data.message.sender
                                      ]?.Name?.replace("/", " ")
                                    : truncateWalletAddress(
                                        item.data.message.sender
                                      )}
                                </div>

                                <div className="flex gap-2 truncate">
                                  <span className="truncate text-sm">
                                    Sent new message
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="flex items-center gap-3 flex-shrink-0">
                              <PropertyImageWithFallback
                                src={getImageUrl(nfts[item.data.nftId], item.data.nftId)}
                                alt="Property"
                                className="w-[60px] h-[60px] rounded-[4px]"
                              />
                              <div>
                                <div className="text-[12px] text-end">
                                  {formattedDate.date}
                                </div>
                                <div className="text-[12px] text-end">
                                  {formattedDate.time}
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      }
                    })}
                </div>
              ) : (
                <div className="bg-white flex flex-col justify-around items-center border border-[#E3E3E3] rounded-[10px] p-6 shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)] h-[220px] sm:h-[300px]">
                  <Fade cascade>
                    <EmptyInbox />
                    <div className="flex flex-col items-center">
                      <div className="font-semibold text-base">No notifications yet</div>
                      <div className="text-[#959595] font-normal text-sm text-center">
                        Your inbox is empty yet
                      </div>
                    </div>
                    <div className="w-full max-w-[200px]">
                      <PurpleButton
                        text={
                          <div className="min-w-[100px] text-center text-sm">Inbox</div>
                        }
                        onClick={() => navigate("/dashboard/traveler/inbox")}
                      />
                    </div>
                  </Fade>
                </div>
              )}
            </div>
          </div>
        </div>
        </div>
      </div>
    </div>
  );
};
